<template>

    <section class="max-w-screen-lg mx-auto w-full py-12 px-6">
        <div class="grid md:grid-cols-2 gap-24 items-start">
            <div class="space-y-6">
                <h2 class="text-4xl font-bold text-white">Seamless authorization, no extra work</h2>
                <p class="text-neutral-50">

                    Unified removes the complexity of integration authorization so you can focus on
                    building your product, not managing OAuth flows. Our pre-built UI and flexible API handle
                    everything in the background—no extra setup required.

                </p>

                <a :href="docsUrl ?? 'https://docs.unified.to/auth/overview#instructions'"
                    class="text-blue-500 flex items-center gap-2">
                    See documentation
                    <Icon name="ic:round-keyboard-arrow-right" />
                </a>
            </div>
            <div>
                <AuthCode workspace_id="12345" />
                <!-- <img src="/images/auth_components.png" alt="Embedded authorization components"
                        class="w-full h-auto object-contain max-h-80" /> -->
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
defineProps<{ docsUrl?: string }>();
</script>
